import { RawGalleryItem } from "./RawGalleryItem";


export class GalleryItem
{
    public Name: string;
    public OriginalUrl: string;
    public NormalizedUrl: string;
    public ThumbnailUrl: string;
    public MiniUrl: string;

    constructor(raw: Partial<RawGalleryItem>)
    {
        this.Name = raw.Name || "";
        this.OriginalUrl = raw.OriginalUrl || "";
        this.NormalizedUrl = raw.NormalizedUrl || "";
        this.ThumbnailUrl = raw.ThumbnailUrl || "";
        this.MiniUrl = raw.MiniUrl || "";
    }
}
